<template>
  <main class="TeamPage">
    <section class="TeamPage__info">
      <h1 class="TeamPage__info-title">Our Team</h1>
    </section>
    <section class="TeamPage__team">
      <TeamCard
        v-for="(item, index) in team"
        :key="index"
        :initial="item.initials"
        :post="item.post"
        :image="item.image"
        :linked-in="item.linkedIn"
      />
    </section>
    <section class="TeamPage__joinus">
      <h2 class="TeamPage__joinus-title">Join the At-HOME Manufacturing Revolution</h2>
      <talk-to-us-button />
      <img class="TeamPage__joinus-figure" src="/img/background-shapes/logo-grey.svg" />
    </section>
  </main>
</template>
<script>
import TeamCard from "../components/items/TeamCard";
import { TEAM } from "../assets/team";

export default {
  components: {TeamCard},
  data: () => ({
    team: TEAM
  })
}
</script>
<style lang="scss">
.TeamPage {
  text-align: center;
  padding-top: 90px;
  @include content;
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    &-title {
      font-weight: bold;
      font-size: 72px;
      line-height: 110%;
      margin-bottom: 30px;
    }
    &-text {
      font-size: 18px;
      line-height: 150%;
      width: 40%;
      @media screen and (max-width: 775px) {
        font-size: 16px;
        width: 100%;
      }
    }
  }
  &__team {
    display: flex;
    flex-wrap: wrap;
    @media screen and (max-width: 1172px) {
      justify-content: center;
    }
    @media screen and (max-width: 775px) {
      margin-bottom: 50px;
    }
  }
  @media screen and (max-width: 775px) {
    padding-top: 120px;
  }
  &__joinus {
    position: relative;
    color: $color;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 200px 0 100px;
    &-title {
      @include joinus-title;
    }
    &-figure {
      position: absolute;
      z-index: -1;
    }
    @media screen and (max-width: 775px) {
      margin: 0 0 60px 0;
    }
  }
  @media screen and (max-width: 775px) {
    padding: 140px 3% 0;
  }
}
</style>
